import React from 'react';
import PropTypes from 'prop-types';

import {
  ReceituarioContainer,
  UnblockerButton,
  UnblockerButtonLabel,
  MedicineList,
  ActionArea,
} from './styles';

import { Icon, Button } from '~/shared/components';
import { Theme } from '~/styles';
import { PatientData, MedicineItem } from './components';
import MevoModal from './components/mevoModal';
import api from '~/services/api';

const Receipt = ({
  prescriptionData = null,
  showingData = null,
  prescriptionItems = null,
  setModalAsOpen,
  validationCode = false,
  setpdfOpen,
}) => {
  const [showMevoModal, setShowMevoModal] = React.useState(false);

  const validateMevoToken = (itens) => {
    return itens.every((medication) => medication.mevo_token !== null);
  };

  const hasMevoExternalId = (itens) => {
    return itens.some((medication) => medication.mevo_external_id);
  };

  const postMevoData = async () => {
    return api.post(`/mevo/prescription`, {
      document: {
        id: prescriptionData.id,
        emissionDate: prescriptionData.datetime,
      },
      healthProfessional: {
        id: prescriptionData.doctor.id,
        name: prescriptionData.doctor.name,
        classCode: {
          origin: prescriptionData.doctor.class_code.origin,
          code: prescriptionData.doctor.class_code.code,
          description: prescriptionData.doctor.class_code.classification,
        },
      },
      patient: {
        id: prescriptionData.patient.id,
        name: prescriptionData.patient.name,
        phone: prescriptionData.patient.phone,
        birthDate: '',
        biologicalSex: '',
        document: '',
        email: '',
      },
      medications: prescriptionItems
        .filter((medication) => medication.mevo_external_id !== null)
        .map((medication) => ({
          id: medication.id,
          externalId: medication.mevo_external_id,
          description: medication.description,
          instructions_use: medication.instructions_use,
        })),
    });
  };

  return (
    <ReceituarioContainer>
      <MevoModal
        show={showMevoModal}
        onClose={() => setShowMevoModal(false)}
        onConfirm={postMevoData}
      />
      <PatientData showingData={showingData} />
      {!prescriptionData && (
        <UnblockerButton
          onClick={() => {
            if (validationCode) {
              setpdfOpen();
            } else {
              setModalAsOpen(true);
            }
          }}
        >
          <Icon name="lock" size="20px" />
          <UnblockerButtonLabel>Visualizar dados</UnblockerButtonLabel>
        </UnblockerButton>
      )}
      <MedicineList unlocked={!!prescriptionData}>
        {prescriptionItems.map((prescription) => {
          return (
            <MedicineItem
              key={prescription.id}
              id={prescription.id}
              medicine={prescription.description}
              description={prescription.instructions_use}
              isControlled={!!prescription.controlled}
              mevoExternalId={prescription.mevo_external_id}
              mevoToken={prescription.mevo_token}
              prescriptionData={prescriptionData}
              mevoCallback={postMevoData}
            />
          );
        })}
      </MedicineList>
      {prescriptionData && prescriptionItems && (
        <ActionArea>
          {hasMevoExternalId(prescriptionItems) &&
            !!prescriptionData?.patient?.phone &&
            prescriptionItems.length > 1 && (
              <Button
                variant="outlined"
                margin={`${Theme.spacing.base} 0 ${Theme.spacing.base} 0`}
                onClick={() => {
                  validateMevoToken(prescriptionItems)
                    ? window.open(
                        `${process.env.REACT_APP_MEVO_URL}/${prescriptionItems[0].mevo_token}`
                      )
                    : setShowMevoModal(true);
                }}
              >
                <span>Comprar medicamentos</span>
              </Button>
            )}
          {prescriptionItems.some(
            (prescriptionItem) => !!prescriptionItem.controlled
          ) && (
            <Button
              margin={`0 0 ${Theme.spacing.base} 0`}
              onClick={() => setpdfOpen()}
            >
              <span>Visualizar receitas controladas (PDF)</span>
            </Button>
          )}
        </ActionArea>
      )}
      {!!prescriptionData && (
        <ActionArea>
          <Button
            margin={`${Theme.spacing.base} 0 40px 0`}
            onClick={() => setpdfOpen()}
          >
            <span
              style={{
                marginRight: Theme.spacing.base,
              }}
            >
              Visualizar documentação (PDF)
            </span>
            <Icon name="download" size="20px" color="white" />
          </Button>
        </ActionArea>
      )}
    </ReceituarioContainer>
  );
};

Receipt.propTypes = {
  setpdfOpen: PropTypes.func.isRequired,
  prescriptionData: PropTypes.any,
  showingData: PropTypes.objectOf({
    date: PropTypes.string,
    doctorArticle: PropTypes.string,
    doctorClassCode: PropTypes.string,
    doctorClassCodeType: PropTypes.string,
    doctorClassOrigin: PropTypes.string,
    doctorName: PropTypes.string,
    patientName: PropTypes.string,
  }),
  prescriptionItems: PropTypes.any,
  setModalAsOpen: PropTypes.any,
  validationCode: PropTypes.bool,
};

Receipt.defaultProps = {
  prescriptionData: null,
  showingData: null,
  prescriptionItems: null,
  setModalAsOpen: null,
  validationCode: null,
};

export default Receipt;
